import block from './block.json';

export const videoThemeAttributes = {
	caption: {
		color: '@tokens.variants.default.contentColor',
		typography: '@tokens.typographies.caption',
		textAlignment: 'left',
	},
	play: {
		width: [32, 48],
		height: [32, 48],
		background: '@tokens.variants.default.backgroundColor',
		foreground: '@tokens.variants.default.titleColor',
	},
	states: {
		hover: {}, // adds hover state
	},
};

export const VideoThemeControls: ThemeControlsType = {
	// What's displayed
	title: block.title,

	// Unique string/id of the block (= the key used in theme.json)
	slug: block.slug,

	// styling attributes available for this block
	// ...the same way we define attributes for a gutenberg block
	attributes: videoThemeAttributes,

	// this renders in the Customizer panel
	// ...the same way "<InspectorControls />" renders in the gutenberg panel
	edit: () => null,
};
